import React, { FC } from "react";
import { Tooltip } from "react-tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export interface BookedNightsData {
    property_id: string;
    booked_nights: number;
    quota: number;
    percentage: number;
    lang?: string;
}

interface BookedNightsCounterProps {
    data: BookedNightsData;
    year: number;
}

const BookedNightsCounter: FC<BookedNightsCounterProps> = ({ data, year }) => {
    const percentage = Math.min(data.percentage, 100);

    return (
        <div className="px-4 sm:min-w-[260px]">
            <div className="flex items-center gap-3">
                <div className="flex items-center justify-center w-9 h-9 rounded-full bg-[#E6EEF1] flex-shrink-0">
                    <i className="las la-home text-xl text-[#0c586e]"></i>
                </div>
                <div>
                    <div className="flex items-center gap-2">
                        <span className="text-sm font-semibold text-neutral-700">
                            Primary Residence Status
                        </span>
                        <>
                            <InfoOutlinedIcon fontSize="small" 
                                data-tooltip-id="booked-nights-info"
                                data-tooltip-content={
                                    data.lang === 'fr'
                                        ? `Pour les résidences principales, les locations de courte durée sont limitées à un maximum de ${data.quota} nuits par année civile, conformément à la réglementation locale.`
                                        : `For primary residences, short-term rentals are limited to a maximum of ${data.quota} nights per calendar year, in accordance with local regulations.`
                                }
                                className="w-4 h-4 text-neutral-600 cursor-pointer"
                            />
                            <Tooltip
                                id="booked-nights-info"
                                place="bottom"
                                style={{ maxWidth: '260px', fontSize: '12px', lineHeight: '1.5' }}
                            />
                        </>
                    </div>
                    <span className="text-xs text-neutral-600 block leading-none mt-0.5">
                        Nights booked in {year}
                    </span>
                </div>
            </div>

            <div className="flex items-baseline gap-1 mt-2">
                <span className="text-2xl font-bold text-neutral-800">
                    {data.booked_nights}
                </span>
                <span className="text-sm">
                    / {data.quota} nights
                </span>
            </div>
            <div className="flex items-center gap-2">
                <div className="flex-1 h-1.5 bg-neutral-200 rounded-full overflow-hidden">
                    <div
                        className="h-full rounded-full"
                        style={{
                            width: `${percentage}%`,
                            backgroundColor: '#0c586e',
                        }}
                    />
                </div>
                <span
                    className="text-sm"
                >
                    {data.percentage}%
                </span>
            </div>
        </div>
    );
};

export default BookedNightsCounter;